// src/utils/adminActions.ts

import { apiRequest } from './api';
import type { MessageSetter } from './messages';

interface AdminActionOptions {
  /** Text for window.confirm(...) prompt; if omitted, no confirm dialog is shown */
  confirmPrompt?: string;
  /** Message setter for error/success text */
  setMessage: MessageSetter;
  /** Custom success text; if not provided, uses data.success/message */
  successMessage?: string;
  /** Called when the action returns successfully and data.success === true */
  onSuccess?: (data: any) => void;
}

/**
 * Run an admin POST action under /api/admin/* with consistent error handling.
 */
export async function runAdminAction(
  path: string,
  { confirmPrompt, setMessage, successMessage, onSuccess }: AdminActionOptions
) {
  if (confirmPrompt && !window.confirm(confirmPrompt)) return;

  try {
    const apiUrl = window.location.origin;
    const data = await apiRequest<any>(`${apiUrl}${path}`, {
      method: 'POST',
      mode: 'cors',
    }, {
      useAuth: true, // Admin endpoints require authentication
      setMessage,
    });

    if (data?.success) {
      if (successMessage) {
        setMessage({ type: 'success', text: successMessage });
        setTimeout(() => setMessage(null), 3000);
      }
      onSuccess?.(data);
    } else {
      setMessage({
        type: 'error',
        text: data?.error || 'Unknown error during admin action',
      });
    }
  } catch (error) {
    console.error('Admin action error:', error);
    // apiRequest already set the error message if setMessage was provided
  }
}

